import { ErrorPage } from '@sbercloud/uikit-product-error-pages';
import React from 'react';

import { APP_BASE_PATH } from '@/constant/common';
import { AppLayout } from '@/layout/Layout';
import { getGlobalArgs } from '@/root/global';

import s from './style.module.scss';

export function GlobalErrorPage() {
  return (
    <AppLayout>
      <ErrorPage
        className={s.error_page_wrapper}
        mainPageUrl={`${getGlobalArgs('NEXT_PUBLIC_CONTENT_BASE_URL', '')}${APP_BASE_PATH}`}
      />
    </AppLayout>
  );
}
